





























import { RootState } from "@/store";
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
    computed: {
        ...mapState({
            loomisStyle: (state: RootState) => state.application.startupData.brandedMode,
        }),
        version() {
            return process.env.VERSION;
        },
    },
});
